import React from 'react';
import { motion } from 'framer-motion';
import splitLine from 'ReactApp/Services/MotionHelpers/SplitLine';
import { CommonLabelsEnum, ProductSaleStatusTypeEnum } from 'ReactApp/Types/enum';
import { priceFormatter } from 'ReactApp/Services/Formatters/PriceFormatter';
import { ShowableProductCard } from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import { observer } from "mobx-react";
import BadgeV1 from "ReactApp/Components/BadgeV1/BadgeV1";

const sentence = {
    visible: {
        transition: {
            delay: 1,
            staggerChildren: 0.05,
            staggerDirection: 1,
        },
    },
}

type PriceBlockV1Props = {
    productCard: ShowableProductCard
}

const PriceBlockV1 = observer((props: PriceBlockV1Props) => {

    if (props.productCard.saleStatusType === ProductSaleStatusTypeEnum.discontinued) {
        return (
            <>
                <motion.div
                    className='sale-price-v1 sale-price-v1__no-price'
                    variants={sentence}
                    initial="hidden"
                    animate="visible"
                >
                    {splitLine(CommonLabelsEnum.productDiscontinued)}
                </motion.div>
            </>
        );
    }

    if (props.productCard.salePrice === null) {
        return (
            <>
                <motion.div
                    className='sale-price-v1 sale-price-v1__no-price'
                    variants={sentence}
                    initial="hidden"
                    animate="visible"
                >
                    {splitLine(CommonLabelsEnum.productHasNoPrice)}
                </motion.div>
            </>
        );
    }

    function renderOldPrice() {
        if (typeof props.productCard.oldPrice?.value === 'number') {
            return (
                <div className="old-price-v1">
                    <span className="old-price-v1__label"></span>
                    <motion.span
                        className='old-price-v1__value'
                        variants={sentence}
                        initial="hidden"
                        animate="visible"
                    >
                        {splitLine(priceFormatter.format(
                            Number(props.productCard.oldPrice.value)
                        ))}
                    </motion.span>
                </div>
            );
        }
    }

    function renderSavingMoney() {
        if (
            typeof props.productCard.oldPrice?.value === 'number'
            &&
            typeof props.productCard.salePrice?.value === 'number'
        ) {
            return (
                <div className="saving-money-v1">
                    <motion.span
                        className='saving-money-v1__value'
                        variants={sentence}
                        initial="hidden"
                        animate="visible"
                    >
                        {splitLine(priceFormatter.format(
                            Number(props.productCard.oldPrice?.value)
                            -
                            Number(props.productCard.salePrice?.value)
                        ))}
                    </motion.span>
                    <span className="saving-money-v1__label"> - скидка</span>
                </div>
            );
        }
    }

    return (
        <>
            {
                props.productCard.oldPrice?.value !== null && (
                    <motion.div className="product-card-v1__price-discount-wrapper">
                        {renderOldPrice()}
                        <BadgeV1
                            label={
                                (props.productCard.discountPercentage
                                    ? "-" + props.productCard.discountPercentage + '%'
                                    : '')
                            }
                            classes={[
                                'badge-v1__discount-label',
                                'badge-v1_text-color-type-white',
                                'badge-v1_filling-color-type-main',
                                'badge-v1_filling-type-contained',
                                'badge-v1_icon-color-type-white',
                                'badge-v1_content-type-label',
                            ]}/>
                    </motion.div>
                )
            }
            {
                props.productCard.oldPrice?.value !== null &&
                props.productCard.salePrice?.value !== null &&
                renderSavingMoney()
            }

            <motion.div
                className='sale-price-v1'
                variants={sentence}
                initial="hidden"
                animate="visible"
            >
                {splitLine(priceFormatter.format(props.productCard.salePrice.value))}
            </motion.div>
        </>
    );

})

export default PriceBlockV1;